import { useMemo } from 'react';
import { StyledButton, StyledDirections } from '@/components/styles';
import Swiper from 'react-id-swiper';

export default function Directions({ directions, active, onClick, size = 'large', center }) {
  const activeI = [...directions].findIndex((dir) => dir?.slug == active?.slug);
  const params = {
    slidesPerView: 'auto',
    shouldSwiperUpdate:true,
    rebuildOnUpdate:true,
    initialSlide: activeI,
    updateOnWindowResize: true,
    on: {
      update: function(){
        this.slideTo([...directions].findIndex((dir) => dir?.slug == active?.slug))
      }
    } 
  };
  return (
    <StyledDirections size={size} center={center}>
      <StyledDirections.Content>
        <Swiper {...params}>
          {directions.map((direction) => {
            const { id, title, slug } = direction;

            const isActive = active?.slug == slug;

            return (
              <StyledDirections.Item key={id}>
                <StyledButton size={size} light={!isActive} onClick={() => onClick && onClick(slug)}>
                  {title}
                </StyledButton>
              </StyledDirections.Item>
            );
          })}
        </Swiper>
      </StyledDirections.Content>
    </StyledDirections>
  );
}
